import { SectionScroll } from './SectionScroll'
import { Link } from 'react-router-dom'
import './EngineeringEnvironmentSection.css'
import { EngineeringEnvironmentPreview } from './EngineeringEnvironmentPreview'

export function EngineeringEnvironmentSection() {
  return <section id="engineering-environment" className="aee-introduction" aria-labelledby="aee-heading" tabIndex={-1}>
    <div className="aee-introduction__inner">
      <div className="aee-introduction__copy">
        <span className="aee-introduction__eyebrow">02 / ALDAPA ENGINEERING ENVIRONMENT</span>
        <h2 id="aee-heading">Your engineering.<br/>One environment.</h2>
        <p className="aee-introduction__lead">Bring your notebooks, code, data, and models together in the Aldapa Engineering Environment.</p>
        <p>Document your thinking, develop calculations, and organize the files behind your engineering work. Move between tools while keeping everything connected to your project.</p>
        <Link className="aee-introduction__launch" to="/signin">Enter the Engineering Environment <span aria-hidden="true">↗</span></Link>
        <span className="aee-introduction__signin">Sign in with your Aldapa account to get started.</span>
      </div>
      <EngineeringEnvironmentPreview />
      <div className="aee-introduction__features">
        <article><span>01 / DOCUMENT</span><h3>Engineering notebooks</h3><p>Keep notes, equations, and technical documentation alongside your project work.</p></article>
        <article><span>02 / DEVELOP</span><h3>Code & calculations</h3><p>Work with AML files and organize engineering calculations in a dedicated workspace.</p></article>
        <article><span>03 / CONNECT</span><h3>Models & project data</h3><p>Organize system models, geometry, tables, and supporting files in the same project.</p></article>
      </div>
    </div>
    <SectionScroll target="home-software" label="Explore software" light />
  </section>
}
